<template>
  <div class="fabu">
    <div class="inner">
      <h2 class="fabu1">{{ detail["journalismTitle" + En] }}</h2>
      <div class="fabu2">
        <span>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
          {{ detail.releaseTime }}
        </span>
        <span>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/fabu.png" alt="">
          {{ detail["journalismSource" + En] }}
        </span>
      </div>
      <div class="fabu3">
          <div v-if="detail.journalismVideo" class="detailVideo">
            <video x5-playsinline="" playsinline="" webkit-playsinline="" :src="detail.journalismVideo" controls="controls"></video>
          </div>
          <div
            class="vhtml"
            v-html="detail['journalismContent' + En]"
            v-else
          ></div>
      </div>
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";
export default {
  data() {
    return {
      detail: {},
      hotSpot: "",
      recommendsList: [],
      source: ""
    };
  },
  created() {
    this.uuid = this.$route.query.uuid;
    this.getData();
  },
  activated() {
    this.uuid = this.$route.query.uuid;
    this.getData();
  },
  watch: {
    En() {
      this.getData()
    }
  },
  methods: {
    getData() {
      // 新闻详情
      protal.queryJournalism(this.uuid).then((res) => {
        if (res && res.data) {
          this.detail = res.data;
          
          this.detail['journalismContent'] = this.detail['journalismContent'].replace(/<iframe.*?<\/iframe>/g, (x) => {
              const src = x.match(/src=\".*\"/)[0].slice(5, -1)
              return `<video @ended="endVideo('end')" src="${src}" controls></video>`
          })
          this.detail['journalismContentEn'] = this.detail['journalismContentEn'].replace(/<iframe.*?<\/iframe>/g, (x) => {
              const src = x.match(/src=\".*\"/)[0].slice(5, -1)
              return `<video @ended="endVideo('end')" src="${src}" controls></video>`
          })
        }
      });
    },
    newsDetail(uuid) {
      this.uuid = uuid;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.detailVideo {
  width: 100%;

  video {
    width: 100%;
  }
}

@media screen and (min-width: 769px) {
  .fabu {
    padding: 1.24rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/zixun-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 12rem;
      min-height: calc(100vh - 1.24rem);
      background: #F6F7F7;
      border-radius: 0.16rem;
      margin: 0 auto;
      padding: .31rem .6rem;

      .fabu1 {
        font-size: .26rem;
        color: #3E3A39;
        line-height: 1.5;
      }

      .fabu2 {
        margin-top: .2rem;
        display: flex;
        align-items: center;
        font-size: .2rem;
        line-height: .22rem;
        padding-bottom: .19rem;
        border-bottom: 1px solid #D9D9D9;

        span {
          display: flex;
          align-items: center;
          margin-right: .44rem;

          img {
            width: .22rem;
            height: .22rem;
            margin-right: .06rem;
          }
        }
      }

      .fabu3 {
        margin-top: .2rem;
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .fabu {
    padding: 1.24rem 0;
    background: #fff;
    background-size: 100% auto;

    .inner {
      width: 100%;
      margin: 0 auto;
      padding: .4rem;

      .fabu1 {
        font-size: .36rem;
        color: #3E3A39;
        line-height: 1.5;
      }

      .fabu2 {
        margin-top: .2rem;
        font-size: .24rem;
        line-height: .36rem;
        padding-bottom: .19rem;
        border-bottom: 1px solid #D9D9D9;

        span {
          display: flex;
          align-items: center;
          margin-right: .44rem;

          img {
            width: .26rem;
            height: .26rem;
            margin-right: .08rem;
          }
        }
      }

      .fabu3 {
        margin-top: .2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fabu/index.vue